"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Oops = void 0;
var oops_1 = require("./oops");
Object.defineProperty(exports, "Oops", { enumerable: true, get: function () { return __importDefault(oops_1).default; } });
//# sourceMappingURL=index.js.map